import { ICompanyDataModel } from '../../data-models/company.data-model';
import { useSampleCompanies } from '../../components/FrostedGate/useSampleCompanies';
import { PREVIEW_KPI_COMPANY_MODELS } from './kpi-module.fixtures';

/** The KPI sample companies, carrying the fields the KPI grids show, spread across the tenant's sectors. */
export function useSampleKpiCompanies(): ICompanyDataModel[] {
  return useSampleCompanies(PREVIEW_KPI_COMPANY_MODELS);
}
